import { BaseResponse } from './internal/baseresponse';

export class AddressState {
  zipcode: string;
  country: string;
  state: string;
  city: string;
  street: string;
  state_local: string;
  city_local: string;
  street_local: string;
};

export class AddressSearchResult extends BaseResponse {
  data?: Array<AddressState> = new Array<AddressState>();
}



// WEBPACK FOOTER //
// ./src/app/response/addressresult.ts